const iconsMixins = {
  props: {
    fill: {
      type: Object,
      default: function () {
        return this?.defaultStatusFill
      }
    }
  },

  computed: {
    fillClass() {
      return this.fill ? `fill${this.fill.icon}` : `fill${this?.defaultStatusFill.icon}`
    },
    bgClass() {
      return this.fill ? `bg${this.fill.bg}` : `bg${this?.defaultStatusFill.bg}`
    }
  }
}

export default iconsMixins
